module.exports = __webpack_public_path__ + "static/img/nav08.4732aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav08.png
// module id = RLRf
// module chunks = 2